export default {
  methods: {
    helper_checkIfInputIsEmpty(e) {
      let inputElement = e.target;
      if (inputElement.value.length > 0) {
        inputElement.classList.remove("empty");
      } else {
        inputElement.classList.add("empty");
      }
    },

    helper_togglePasswordVisibility(e) {
      let passwordElement = e.currentTarget.parentElement.children[1];
      let passwordTogglerBtn = e.currentTarget;
      if (passwordElement.type == "password") {
        passwordElement.type = "text";
        passwordTogglerBtn.classList.add("password_is_visible");
      } else if (passwordElement.type == "text") {
        passwordElement.type = "password";
        passwordTogglerBtn.classList.remove("password_is_visible");
      }
    },

    helper_validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    helper_filterSearch(value, search, item) {
      if (search == "all") return true;
      return value != null && search != null && value.indexOf(search) !== -1;
    },
  },
};
